import React from "react";
import { DownloadPdfButtonRoot } from "./DownloadPdfButton.styles";
import { Typography } from "@mui/material";

interface DownloadPDFProps {
    base64String: string; // Base64 encoded PDF string
    fileName?: string; // Optional file name for the download
}

const DownloadPDFButton: React.FC<DownloadPDFProps> = ({
    base64String,
    fileName = "download.pdf",
}) => {
    const handleDownload = () => {
        try {
            // Remove the `data:application/pdf;base64,` prefix if present
            const cleanBase64String = base64String.replace(/^data:application\/pdf;base64,/, "");

            // Convert the base64 string to a binary Blob
            const byteCharacters = atob(cleanBase64String);
            const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });

            // Create a URL for the Blob and trigger the download
            const blobURL = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobURL;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Clean up the Blob URL
            URL.revokeObjectURL(blobURL);
        } catch (error) {
            console.error("Failed to download PDF:", error);
        }
    };
    return (
        <DownloadPdfButtonRoot>
            <button onClick={handleDownload}>
                <Typography>Baixar PDF</Typography>
            </button>
        </DownloadPdfButtonRoot>
    );
};

export default DownloadPDFButton;
